import { StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import { isWeb } from '../../../constants';
// On web an activity card is padded by 8 and each row by 8 on every side, so the hover highlight
// sits 8 inside the card and the content 16 from the card edge.
const styles = StyleSheet.create({
    row: { paddingVertical: rem(8) },
});
/**
 * Web only: the extra style for an activity row inside a card. Undefined on mobile, so callers
 * can keep their mobile style unchanged.
 */
const webActivityRowStyle = isWeb ? styles.row : undefined;
export default webActivityRowStyle;
